module.exports = __webpack_public_path__ + "img/hardwareOpen4.a427212f.png";